import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CalendarEditIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 14V16H11L16 11L14 9L9 14Z" />
        <path d="M13 2H15C15.552 2 16 2.448 16 3V7.5H14V5H2V14H7V16H1C0.448 16 0 15.552 0 15V3C0 2.448 0.448 2 1 2H3V0H6V2H10V0H13V2Z" />
        <path d="M4 7H6V9H4V7Z" />
        <path d="M9 7H7V9H9V7Z" />
        <path d="M4 10H6V12H4V10Z" />
        <path d="M9 10H7V12H9V10Z" />
        <path d="M10 7H12V9H10V7Z" />
      </svg>
    </Icon>
  );
}
